import { useMount, useRequest } from "ahooks";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";

import { Env } from "@/config/env";
import {
  REFRESH_TOKEN_IN_COOKIE,
  TOKEN_EXPIRE,
  TOKEN_IN_COOKIE,
} from "@/libs/constants";
import { isUnreadMessageState, staffState } from "@/models";
import { authLogoutReq } from "@/services/api/api-auth";
import { getUnreadNotificationsApi } from "@/services/api/notifications";
import { localRemove } from "@/utils/storage";

export const useUserModalStore = () => {
  const navigator = useNavigate();

  const [staff, setStaff] = useRecoilState(staffState);

  const [isUnreadMessage, setIsUnreadMessage] =
    useRecoilState(isUnreadMessageState);

  const token = Cookies.get(TOKEN_IN_COOKIE);

  const getUnreadNotificationsRequest = useRequest(getUnreadNotificationsApi, {
    manual: true,
    onSuccess: (res) => {
      const { meta } = res;

      setIsUnreadMessage(meta.total > 0);
    },
  });

  const handleLogout = () => {
    const params = new URLSearchParams();

    const webUrl = new URL(Env.WEB_URL + "/callback");

    params.append("post_logout_redirect_uri", webUrl.toString());
    const authorizeEndpoint = Env.OME_URL + "/connect/logout";

    localRemove(TOKEN_EXPIRE);

    Cookies.remove(REFRESH_TOKEN_IN_COOKIE);
    Cookies.remove(TOKEN_IN_COOKIE);
    Cookies.remove(TOKEN_IN_COOKIE, {
      domain: Env.DOMAIN,
    });
    Cookies.remove(REFRESH_TOKEN_IN_COOKIE, {
      domain: Env.DOMAIN,
    });
    setStaff(null);
    window.location.href = `${authorizeEndpoint}?${params.toString()}`;

    return;
    // ome-account.wiltechs.com/connect/logout
    authLogoutReq().then(() => {
      localRemove(TOKEN_EXPIRE);
      Cookies.remove(TOKEN_IN_COOKIE, {
        domain: Env.DOMAIN,
      });
      setStaff(null);
      navigator("/callback");
    });
  };

  useMount(() => {
    token && getUnreadNotificationsRequest.run();
  });

  return {
    staff,
    isUnreadMessage,
    handleLogout,
  };
};
